/**
 * Versioned URL for a file under `public/assets`, e.g.
 * `assetUrl("anvil-animations/anvil-idle-dark.png")` →
 * `/assets/anvil-animations/anvil-idle-dark.png?v=1a2b3c4d5e6f`.
 *
 * In prod/staging, /assets responses are cached immutably for a year
 * (next.config.js headers()); the ?v= build-time content hash of the assets
 * tree is the only cache buster. Referencing an asset as a raw "/assets/..."
 * string would leave it stale in browsers after it changes, so always go
 * through this helper (enforced by no-restricted-syntax in eslint.config.mjs).
 */
export function assetUrl(path: string): string {
  const version = process.env.NEXT_PUBLIC_ASSET_VERSION;
  return version ? `/assets/${path}?v=${version}` : `/assets/${path}`;
}
